/**
 * Paraguayan guaraní.
 */
export var PYG = {
  code: 'PYG',
  base: 10,
  exponent: 0
};